import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import IconPdf from "../img/icons/icon-pdf.svg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import Pagination from "react-js-pagination";

export default function OperatingResults(prop) {

    let [listing, setListing] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [selectYear, setSelectYear] = React.useState();
    let [yearListing, setYearListing] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);

                    let yearArr = [];
                    for(let rs of resListing.rows) {
                        yearArr.push(prop.lang === 'en' ? new Date(rs.postDate).getFullYear() : new Date(rs.postDate).getFullYear()+543);
                    }
                    if(yearArr) {
                        yearArr = [...new Set(yearArr)];
                    }
                    setYearListing(yearArr);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        const response = await fetch(Config.apiUrl +'operatingResults/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                selectYear: prop.lang === 'en' ? selectYear : selectYear-543,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</span>
                    </h1>
                </div>
            </div>


            <div className="section bg-light">
                <div className="container">
                    <div className="hgroup hgroup-search" data-aos="fade-in">
                        <h2 className="text-center text-primary">{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</h2>
                        <div className="d-flex flex-wrap pt-3">
                            <div className="show-list">
                                <p>แสดงรายการ</p>
                                <select className="form-select" onChange={e => setSelectYear(parseInt(e.target.value))}>
                                    <option value="">{prop.lang === 'en' ? 'Select Year':'เลือกปี'}</option>
                                    {
                                        yearListing && yearListing.length > 0 ?
                                            yearListing.map(function(item, i) {
                                                return <option value={item}>{item}</option>;
                                            }) : ''
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="card-infos">
                        {
                            listing !== null && listing.count > 0 ?
                                <ul className="document-list">
                                    {
                                        listing.rows.map((row, index) => {
                                            return (
                                                <li key={index}>
                                                    <img className="icons" src={IconPdf} alt="PDF" />
                                                    <div>
                                                        <h3><a href={(prop.lang === 'en' ? '/en':'') + '/operating_results/detail/' + row.slug}>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</a>
                                                        </h3>
                                                        <p>{Utils.dateDMY(row.postDate, prop.lang, false)}</p>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul> : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                        }
                    </div>

                    <div className={totalPage > 1 ? '':'d-none'}>
                        <Pagination
                            itemClassPrev="arrow prev"
                            itemClassNext="arrow next"
                            activeClass="active"
                            itemClass=""
                            linkClass=""
                            innerClass="pagination"
                            activePage={activePage}
                            itemsCountPerPage={itemPerpage}
                            totalItemsCount={countAllItem}
                            pageRangeDisplayed={5}
                            onChange={(pageNum) => onPageChange(pageNum)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
} 